import { debounce } from 'lodash'
import {isNarrowDevice} from "../sb/mediaQueries";

const $ = window.jQuery

const body = $('body')
const header = $('#header')
const slider = $('.js-teaserSlider')

const handleScroll = debounce(() => {
  if (!slider.length)
    return
    header.toggleClass('header--bright', (window.scrollY < (slider.offset().top + slider.outerHeight()) && !isNarrowDevice()))
    header.toggleClass('header--fixed', !isNarrowDevice() && body.hasClass('frontpage'))

}, 50)

export const init = () => {
  window.addEventListener('scroll', handleScroll, false)
  window.addEventListener('load', handleScroll, false)
  window.addEventListener('resize', handleScroll, false)
}



//////////////////
// WEBPACK FOOTER
// ./src/js/components/layout.js
// module id = 15
// module chunks = 0